import { Component, inject, signal } from "@angular/core";

import { ButtonComponent } from "@shared/components/button/button.component";
import { PageComponent } from "@shared/components";
import { GlobalService } from "@shared/services";

import { SaveAllComponent } from "@home/components/save-all/save-all.component";
import { SummaryCardsComponent } from "@home/components/summary-cards/summary-cards.component";
import { AccordionsComponent } from "@home/components/accordions/accordions.component";

@Component({
  selector: "app-home",
  standalone: true,
  imports: [PageComponent, SummaryCardsComponent, ButtonComponent, SaveAllComponent, AccordionsComponent],
  templateUrl: "./home.component.html",
  styleUrl: "./home.component.scss",
})
export class HomeComponent {
  globalService = inject(GlobalService);
  saveAllVisible: boolean = false;
  loadAccordions = signal<boolean>(false);

  getPageHeight(): string {
    return `calc(100vh - ${this.globalService.navbarHeight()}px - 100px)`;
  }

  getAccordionData(): void {
    this.loadAccordions.set(true);
  }
}
